import React, { useContext } from 'react';
import { Image } from '@hz-design-system/web-ui';

import EnvironmentContext from '../../../../contexts/EnvironmentContext';
import { getHeroImageUrl, getLargeHeroImageUrl } from '../../../../utils/getImageUrls';

import { TListingGalleryApi } from 'types/TListing';

import Classes from './HeroImage.scss';

type THeroImageProps = {
  imageUrl: string;
  imageSizes: TListingGalleryApi['media']['imageSizes'];
  alt: string;
  onClickHandler: (index: any) => void;
};

// todo: add proper a11y attribute
/* eslint-disable jsx-a11y/click-events-have-key-events */
const HeroImage = ({ imageUrl, alt, onClickHandler, imageSizes }: THeroImageProps) => {
  const { isMobileDevice } = useContext(EnvironmentContext);

  return (
    <div className={Classes.root} onClick={onClickHandler}>
      <Image
        className={Classes.image}
        src={isMobileDevice ? getHeroImageUrl(imageUrl, imageSizes) : getLargeHeroImageUrl(imageUrl, imageSizes)}
        fetchpriority="high"
        alt={alt}
        title={alt}
        aspectRatio="landscape"
        fit={true}
      />
    </div>
  );
};

export default HeroImage;
